import { __awaiter } from "tslib";
import { status } from '@/alas';
import { showError, showSuccess } from '@/store';
import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let t = m => context.root.$t(m);
        let route = context.root.$route;
        let router = context.root.$router;
        // ================
        //
        // refs
        //
        let validate = ref(false);
        let myFarm = ref(status.fetch('farm'));
        let farm = ref(myFarm.value.$copy());
        let confirm = ref(null);
        // ================
        //
        // methods
        //
        let submit = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield farm.value.$o.update.start();
                status.reset('farm');
                showSuccess(t('更新成功'));
                yield status.fetch('farm').$o.fetch.start({
                    farmId: route.params.id
                });
                router.push({
                    name: 'farms.overview'
                });
            }
            catch (error) {
                showError(error);
            }
        });
        let remove = () => {
            confirm.value.open((close) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield farm.value.$o.remove.start();
                    showSuccess(t('刪除成功'));
                    status.reset('farms');
                    router.push({
                        name: 'farms.list'
                    });
                }
                catch (error) {
                    showError(error);
                }
            }));
        };
        // ================
        //
        // done
        //
        return {
            submit,
            remove,
            validate,
            myFarm,
            farm,
            confirm
        };
    }
});
